(function($){
    console.log("custom.js");
})(jQuery);